import React from 'react';
import CategoryNode from './CategoryNode';


const CategoryTree = ({
  categories,
  loading,
  onLoadChildren,
  onAddChild,
  onEdit,
  onView,
  onDelete,
  isSearchMode = false
}) => {
  if (loading) {
    return <div className="bg-white p-6 rounded shadow-sm border">در حال بارگذاری...</div>;
  }

  if (!categories || categories.length === 0) {
    return (
      <div className="bg-white p-6 rounded shadow-sm border text-center text-gray-500">
        {isSearchMode ? 'نتیجه‌ای یافت نشد' : 'هیچ دسته‌ای وجود ندارد'}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="p-4 border-b">
        <h3 className="text-lg font-medium">
          {isSearchMode ? 'نتایج جستجو' : 'درخت دسته‌بندی‌ها'}
        </h3>
      </div>

      <div className="p-4">
        <div className="space-y-1">
          {categories.map((cat) => (
            <CategoryNode
              key={cat.id}
              category={cat}
              level={0}
              onLoadChildren={onLoadChildren}
              onAddChild={onAddChild}
              onEdit={onEdit}
              onView={onView}
              onDelete={onDelete}
              isSearchMode={isSearchMode}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default CategoryTree;
